// Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.

import { createApp } from 'vue';
import technicalAssetUpload from '@protolabs/technical-asset-upload';
import { useTheme } from '@protolabs/component-library';
import { createI18nInstanceAsync } from 'i18n-protolabs';
import { TokenManagerFactory } from '@protolabs/enterprise-token-manager';

import router from './router';
import store from './store/index';
import App from './App.vue';

import tokenManagerConfig from '../tokenManagerConfig';

const tokenManager = TokenManagerFactory.getOrCreateTokenManager(tokenManagerConfig);

import '@protolabs/technical-asset-upload/dist/technicalAssetUpload.css';

const handShaking =
	window.location.href.toLowerCase().indexOf(tokenManagerConfig.redirectUri.toLowerCase()) === 0;

const completeAuth = () => {
	tokenManager
		.completeAuthenticationAsync()
		.then((activeRoute: any) => {
			window.location.replace(activeRoute);
		})
		.catch((error: any) => {
			console.error(error);
			window.location.replace('/');
		});
};

const renderApp = async () => {
	const i18n = await createI18nInstanceAsync({
		disableSync: true,
		baseUrl: window.i18nUrl,
	});

	const vueApp = createApp(App).use(i18n).use(technicalAssetUpload).use(router).use(store);
	useTheme('protolabs-2023');
	vueApp.mount('#document-upload');
};

if (handShaking) {
	completeAuth();
} else {
	tokenManager
		.initializeAsync()
		.then((isAuthenticated: any) => {
			if (isAuthenticated) {
				return Promise.resolve(false);
			} else {
				return tokenManager.startAuthenticationAsync();
			}
		})
		.then((isRedirecting: any) => {
			if (isRedirecting) {
				return;
			}
			renderApp();
		});
}
